import { useSyncExternalStore } from 'react'

/**
 * Registro dei PaneLayout montati. La shell lo legge per scegliere la navigazione sul libro separante
 * (con PaneLayout: rail 96 e pane allineate alla piega; senza: nav nel segmento 0 e pagina nel segmento 1).
 * La geometria resta nel CSS (`.md-shell:has(.md-pane-layout)`): qui serve solo sapere quale nav montare.
 */
let count = 0
const listeners = new Set<() => void>()

export function registerPaneLayout(): () => void {
  count += 1
  listeners.forEach(l => l())
  return () => {
    count -= 1
    listeners.forEach(l => l())
  }
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => { listeners.delete(cb) }
}

export function usePaneLayoutPresent(): boolean {
  return useSyncExternalStore(subscribe, () => count > 0, () => false)
}
